import React, { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import { Text, Stack, HStack } from '@chakra-ui/react';
import TemplateSelectEdit from './TemplateSelectEdit';
import IdentidadeDoPilar from '../../../../components/Questionnaires/IdentidadeDoPilar';

const PillarTabEdit = ({
 index,
 field,
 register,
 errors,
 control,
 templates,
 templatesIsLoading,
}) => {
 const numberOfThemes = parseInt(field?.numberOfThemes) || 0;

 const {
  fields: themes,
  append: appendThemes,
  remove: removeThemes,
 } = useFieldArray({
  control,
  name: `form.${index}.themes`,
 });

 useEffect(() => {
  if (numberOfThemes > 0 && numberOfThemes > themes?.length) {
   // quando o numero de themes aumenta
   if (numberOfThemes > themes?.length) {
    const themesToAdd = numberOfThemes - themes.length;

    for (let i = 0; i < themesToAdd; i++) {
     appendThemes({
      index: themes.length + 1 + i,
      title: '',
      questions: [],
     });
    }
   }
  }
 }, [themes, numberOfThemes, appendThemes]);

 useEffect(() => {
  if (numberOfThemes > 0 && numberOfThemes < themes.length) {
   if (themes?.length > 0) {
    const itemsToRemove = themes?.length - numberOfThemes;

    for (let i = 0; i < itemsToRemove; i++) {
     const lastIndex = themes.length - 1 - i;
     removeThemes(lastIndex);
    }
   }
  }
 }, [numberOfThemes, themes, removeThemes, field]);

 return (
  <Stack spacing='0'>
   {/* EG-42: a identidade do pilar aparece aqui também, em somente leitura,
       igual à certificação. */}
   <IdentidadeDoPilar imgPillar={field?.pillarImage} textPillar={field?.pillarText} />

   {/* EG-42: o tema deixou de ser INPUT EDITÁVEL.
       Ele era um campo de texto livre por tema — e digitar aqui era exatamente
       o que permitia "Emissões" e "Emissoes" nascerem como conceitos distintos,
       o problema que a EG-40 fechou ao levar tema para o catálogo global.
       Pós-EG-42 o tema vem da classificação da pergunta no template, então é
       resultado, não entrada. Apresentado como a certificação apresenta: no
       cabeçalho da seção de perguntas. */}
   {themes?.map((theme, themeIndex) => (
    <Stack key={theme.id} spacing='0'>
     <HStack h='51px' bg='#E6F1F8' p='16px'>
      <Text color='#0073BB' fontWeight={600}>
       Perguntas - {theme?.title || `Tema ${themeIndex + 1}`}
      </Text>
     </HStack>
     <Stack p='6' spacing='6'>
      <TemplateSelectEdit
       themeIndex={themeIndex}
       templates={templates}
       templatesIsLoading={templatesIsLoading}
       control={control}
       pillarIndex={index}
      />
     </Stack>
    </Stack>
   ))}
  </Stack>
 );
};

export default React.memo(PillarTabEdit);
